/* istanbul ignore file */

import { UntypedFormGroup } from '@angular/forms';

import { FilterMenuOptions } from '../../../../models';

export class FilterMenuServiceModel {
    filterMenuOptions: FilterMenuOptions = new FilterMenuOptions();
    expandFilterMenu = false;
    characterCap = 30;
    cutOffString = "...";
    form: UntypedFormGroup = new UntypedFormGroup({});
    seeMoreStatus: { [key: string]: boolean; } = {};
}
